import type { LucideIcon } from "lucide-react";
import { Button } from "@/components/ds/Button";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  text?: string;
  /** One action button. */
  action?: { label: string; onClick: () => void };
}

/** Centred empty state: icon, title, short text and one action. */
export function EmptyState({ icon: Icon, title, text, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center px-4 py-10 text-center font-ds">
      {Icon && (
        <span className="mb-3 grid h-11 w-11 place-items-center rounded-full bg-ds-sunk text-ds-ink3">
          <Icon className="h-5 w-5" aria-hidden="true" />
        </span>
      )}
      <h3 className="text-[15px] font-semibold text-ds-ink">{title}</h3>
      {text && <p className="mt-1 max-w-sm text-[13.5px] text-ds-ink2">{text}</p>}
      {action && (
        <Button className="mt-4" variant="secondary" onClick={action.onClick}>
          {action.label}
        </Button>
      )}
    </div>
  );
}
